const convertHexToRgba = (hex = '#ffffff', opacity = 100): string => {
  let hexColor = hex.replace('#', '');

  if (hexColor.length === 3) {
    hexColor =
      hexColor[0] +
      hexColor[0] +
      hexColor[1] +
      hexColor[1] +
      hexColor[2] +
      hexColor[2];
  }

  if (hexColor.length === 6) {
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);

    const result = `rgba(${r}, ${g}, ${b} , ${opacity / 100})`;
    return result;
  }

  return hex;
};

export default convertHexToRgba;
